import { useAuth } from 'context/authContext'
import Modal from 'react-bootstrap/Modal'
import { useNavigate } from 'react-router-dom'
import posthog from 'posthog-js'

interface IModalProps {
    show: boolean
    onHide: () => void
}
const LogoutModal = ({ show, onHide }: IModalProps) => {
    const { logout } = useAuth()
    const navigate = useNavigate()
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <div className=" w-full text-center py-4 text-xs">
                <p className=" mb-3">مایل به خروج هستید؟</p>
                <hr />
                <p
                    className=" my-2"
                    onClick={() => {
                        // Fire before logout() → posthog.reset() clears the id.
                        posthog.capture('logout')
                        logout()
                        navigate('/auth/login')
                        onHide()
                    }}
                >
                    خروج
                </p>
                <hr />
                <p className=" mt-4 text-green-1" onClick={onHide}>
                    بازگشت
                </p>
            </div>
        </Modal>
    )
}

export default LogoutModal
